export const myProjectsData = [
  /* MAPALYTICS */
  {
    id: 'hjtryjytrsw',
    name: 'Mapalytics',
    paths: [
      {
        img: 'mapalytics/mapalytics.jpg',
        alt: 'Mapalytics consulting platform'
      },
    ],
    thumb: {
      img: 'mapalytics/thumb-mapalytics.jpg',
      alt: 'Mapalytics website',
    },
    ano: 'March, 2024',
    link: 'https://mapalytics.com.br/',
    github: '',
    description: `
      <b>Project portfolio</b>
      <p>Mapalytics is a geomarketing web platform that combines data and public sources to help companies find new leads and sales opportunities anywhere in Brazil.</p>
      <br>
      <b>Development kit</b>
      <br>
      <p>Next.js, HTML, CSS, JavaScript</p>
    `,
  },
  /* Tre */
  {
    id: 'mp2rewfwbiuz',
    name: 'Tre Communication',
    link: 'https://tre-art-4b66f.web.app/',
    paths: [
      {
        img: 'tre/mobile-tre-studio-design.jpg',
        alt: 'Mobile mockup version of Tre Studio website'
      },
      {
        img: 'tre/studio-tre.jpg',
        alt: 'Desktop mockup version of Tre Studio website'
      },
      {
        img: 'tre/website-tre-studio-design.jpg',
        alt: 'Desktop version of Tre Studio website'
      },
    ],
    thumb: {
      img: 'tre/thumb-website-tre-studio-design.jpg',
      alt: 'One-page Tre Designs website | Vue.js HTML CSS'
    },
    github: 'https://github.com/MateusDuraessantos/tre',
    ano: 'February, 2023',
    link: 'https://tre.art.br/',
    description: `
      <b>Project portfolio</b>
      <p><a href="https://tre.art.br/" target="_blank">Tre Communication</a> is a design studio founded in 1990 by designer <a href="https://www.linkedin.com/in/kito-castanha-20b69a21/" target="_blank">Kito Castanha</a>. In 2023, Tre celebrated its 33rd anniversary, and a new website was launched to mark the occasion.</p>
      <br>

      <b>My role</b>
      <br>
      <p>
        <strong>Design</strong>: All of Tre's branding was analyzed and, following the brief, I created a new UX/UI landing page interface. The project was built following design thinking methodologies and prototyped in Figma.
      </p>
      
      <p>
        <strong>Development</strong>: I developed the entire front-end structure, used GitHub to manage and version the code, and finally hosted it on Tre's domain to go live.
      </p>
      <br>
      <b>Development kit</b>
      <br>
      <p>Vue.js 2, JavaScript, HTML, CSS, Firebase Hosting, GitHub and Element Plus.</p>
    `,
  },
  // TCC
  {
    id: 'dfrejmwopqfremn',
    name: 'Design course at Universidade Presbiteriana Mackenzie',
    paths: [
      {
        img: 'tcc/webiste_mackenzie_curso_de_design.jpg',
        alt: 'My final project mockup'
      },
      {
        img: 'tcc/pagina_inicial_do_projeto.jpg',
        alt: 'My final project website'
      },
      {
        img: 'tcc/arvore_de_navegacao_proposta.jpg',
        alt: 'Navigation structure of the website developed in the final project'
      },
    ],
    ano: 'September, 2022',
    thumb: {
      img: 'tcc/thumb-pagina_inicial_do_projeto.jpg',
      alt: 'Final project website - Mackenzie'
    },
    link: 'https://mackenzie-tcc.web.app/#/',
    github: 'https://github.com/MateusDuraessantos/TCC',
    description: `
      <b>Overview</b>
      <br>
      <p>This project is a redesign of the website for the <a href="https://www.mackenzie.br/graduacao/sao-paulo-higienopolis/design" target="_blank">undergraduate Design</a> course at <a href="https://www.mackenzie.br/" target="_blank">Universidade Presbiteriana Mackenzie</a>.</p>
      <br>
      <b>My role</b>
      <p><strong>Design process:</strong> Two main methodologies were used to guide the project: <strong>HCD (Human Centered Design)</strong> and <strong>Jesse James Garrett's 5 elements of UX design</strong>, addressing strategy, scope, structure, skeleton, and surface.</p>
      <p><strong>Development:</strong> I built the project using Vue.js 2, JavaScript, HTML, and CSS. I handled deployment through Firebase Hosting, managed version control on GitHub, and used Element Plus for some interface components.</p>
      <br>
      <p><b>Development:</b> Vue.js 2, JavaScript, HTML, CSS, Firebase Hosting, GitHub and Element Plus.</p>
    `,
  },
  /* Calculadora de KM */
  {
    id: 'usususuuss',
    name: 'Mapalytics - Distance Calculator',
    paths: [
      {
        img: 'calculadora/origins_calculator.mp4',
        type:'mp4',
        alt: 'Mapalytics Data Machina'
      },
      {
        img: 'calculadora/selected_alternatives.png',
        alt: 'Mapalytics Data Machina'
      },
      {
        img: 'calculadora/calculadora.png',
        alt: 'Mapalytics Distance Calculator interface'
      },
      {
        img: 'calculadora/alternatives_selection.mp4',
        type:'mp4',
        alt: 'Mapalytics Data Machina'
      },
    ],
    thumb: {
      img: 'calculadora/thumb.png',
      alt: 'Mapalytics Data Machina'
    },
    github: '',
    ano: 'September, 2025',
    link: 'https://mapalytics.com.br/',
    description: `
      <b>Project portfolio</b>
      <br>
      <p>The Distance Calculator is a tool from a Mapalytics product, by the startup <a href="https://datamachina.com.br/" target="_blank">Data Machina</a>, focused on helping companies analyze their own territorial reach. The tool can receive multiple inputs of origins and destinations of different types and calculate the distances between the selected points all at once.</p>
      <p>Another major feature is the possibility of searching for new leads around your origin point using a customizable radius. It provides insights into which options are better and which are too far away, based on the distance between points.</p>

      <br>
      <b>My Role</b>
      <br>
      <p>
        <strong>Frontend</strong> - I created the entire frontend architecture of the tool using Vue.js 2, HTML, CSS, and JavaScript. I implemented the interactive map features with Mapbox GL and integrated all backend endpoints through Firebase’s httpsCallable functions.
        <br>
        <strong>Design</strong> - In addition to development, I actively contributed to the interface design and user experience. I applied Jesse James Garrett’s “Five Elements of User Experience” methodology to create a clear and efficient interface.
      </p>
    `,
  },
  /* Design System */
  {
    id: '07665849',
    name: 'Design System | Data Machina',
    link: 'https://design-system-dm.web.app',
    paths: [
      {
        img: 'design_system/design_system.png',
        alt: 'Design System Data Machina preview'
      },
      {
        img: 'design_system/website_design_system.png',
        alt: 'Design System Data Machina preview'
      },
      {
        img: 'design_system/design_system_mobile_instagram.jpg',
        alt: 'Design System Data Machina preview'
      },
    ],
    thumb: {
      img: 'design_system/thumb.png',
      alt: 'Design System preview'
    },
    github: 'https://github.com/gustavoemmanoel/DM-Design-System/tree/main',
    ano: 'Aug, 2023',
    description: `
      <b>Project portfolio</b>
      <p>The <a href="https://datamachina.com.br/" target="_blank">Data Machina</a> Design System is a unified visual and functional framework that defines the foundations and components of the brand’s digital products. Built to ensure consistency, scalability, and efficiency, it brings together principles of design, color, typography, iconography, and interaction patterns into a cohesive ecosystem. This first version (v.01) establishes the visual identity and usability standards that guide the creation of all Data Machina interfaces.</p>
      <br>

      <b>My role</b>
      <br>
      <p>
        I was responsible for the entire frontend development of the project. The website was built with Vue.js 2 and Element Plus, hosted through Firebase Hosting. My main goal was to customize and extend all Element Plus components to align them with Data Machina’s visual identity and design principles, ensuring a cohesive and branded user experience across all interfaces.
      </p>
      <br>
      <b>Development kit</b>
      <br>
      <p>Vue.js 2, JavaScript, HTML, CSS, Firebase Hosting, Element Plus and GitHub.</p>
    `,
  },
  // Teclakey
  {
    id: 'zmgvpregujirew',
    name: 'TeclaKey',
    paths: [
      {
        img: 'teclakey/mockup-site-studios-design-teclakey.jpg',
        alt: 'Mobile mockup of the TeclaKey website'
      },
      {
        img: 'teclakey/teclakey-webiste-de-design.jpg',
        alt: 'Desktop version of the TeclaKey website'
      },
      {
        img: 'teclakey/teclakey.gif',
        alt: 'Website animation mockup'
      },
    ],
    ano: 'May, 2022',
    thumb: {
      img: 'teclakey/thumb-teclakey-webiste-de-design.jpg',
      alt: 'TeclaKey website - UX/UI - Firebase',
    },
    link: 'https://tecla-key.web.app/',
    github: 'https://github.com/MateusDuraessantos/teclakeygit',
    description: `
      <b>Project portfolio</b>
      <br>
      <p>TeclaKey is a creative design studio focused on developing customized websites and digital identities. The website was built to clearly communicate the studio's values — transparency, innovation, and empowerment — while providing a simple user experience.</p>
      <br>
      <b>My role</b>
      <p><strong>Design:</strong> While developing the website in collaboration with a three-person team, I coordinated the visual identity design.</p>
      <p><strong>Development:</strong> I was responsible for the front-end development, responsive layout, domain implementation, and web content optimization (SEO).</p>
    `,
  },
  {
    id: 'gtrnieogvreoifg',
    name: 'Data Machina',
    link: 'https://data-machina.web.app/',
    paths: [
      {
        img: 'datamachina/datamachina.jpg',
        alt: 'Mobile mockup of the Data Machina website'
      },
      {
        img: 'datamachina/datamachina_website_onepage.jpg',
        alt: 'Data Machina company website'
      },
    ],
    thumb: {
      img: 'datamachina/thumb-datamachina_website_onepage.jpg',
      alt: 'Data Machina / Frontend project with HTML and CSS',
    },
    ano: 'December, 2021',
    github: 'https://github.com/MateusDuraessantos/site-datamachina-portf',
    description: `
      <b>Project portfolio</b>
      <p>In this project, with the design (for desktop) and content already developed beforehand by other collaborators, I was responsible for building the entire HTML and CSS structure and making it responsive for mobile devices.</p>
      <br>
      <b>Development stack</b>
      <br>
      <p>Vue.js 2, JavaScript, HTML, CSS, GitHub and Element Plus.</p>
    `,
  },
]
